import { useState, useEffect } from "react";
import TreeCare from "./TreeCare";
import { useDispatch, useSelector } from 'react-redux';
import { setOrderData } from "Store/Component/BulkOrder/BulkOrderAction";
import { commonDropDownSelectionChange } from "utils";

const TreeCareContainer = (props?:any) => {
  const { vehicle, managedEquipRef } = props
  const dispatch = useDispatch();
  
  const [manufacturerDropDownList, setManufacturerDropDownList] = useState<any>([]);
  const [equipmentTypeDropDownList, setEquipmentTypeDropDownList] = useState<any>([]);
  const [horsePowerDropDownList, setHorsePowerDropDownList] = useState<any>([]);
  const [fuelTypeDropDownList, setFuelTypeDropDownList] = useState<any>([]);

  const { orderDetails }: any = useSelector((state? : any) => ({
    orderDetails: state.BulkOrderReducer.orderDetails
  }));

  ///Modified dropDown values as required
  useEffect(()=>{
    let dropdownList:any =  vehicle?.searchDropdowns?.length ? JSON.parse(JSON.stringify(vehicle?.searchDropdowns)) : []
    if (dropdownList?.length > 0) {
      dropdownList?.map((item: any) => {
        if (item?.dropdownName == "Manufacturer") {
          const defaultManufacturerOption = {
            text: "Select Manufacturer",
            value: null
          };
          item?.dropdownList?.unshift(defaultManufacturerOption);
          let manufacturerDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setManufacturerDropDownList(manufacturerDropdownListTemp)
        } else if (item?.dropdownName == "Equipment Type") {
          const defaultEquipmentTypeOption = {
            text: "Select Equipment Type",
            value: null
          };
          item?.dropdownList?.unshift(defaultEquipmentTypeOption);
          let equipmentTypeDropdownListTemp = item?.dropdownList?.map((val: any) =>
              ({ text: val.text, value: val.value, label: val.text, key: val.value })
            );
          setEquipmentTypeDropDownList(equipmentTypeDropdownListTemp)
        }else if (item?.dropdownName == "Horse Power") {
          const defaultHorsePowerOption = {
            text: "Select Horse Power",
            value: null
          };
          item?.dropdownList?.unshift(defaultHorsePowerOption);
          let horsePowerDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setHorsePowerDropDownList(horsePowerDropdownListTemp)
        }else if (item?.dropdownName == "Fuel Type") {
          const defaultFuelTypeOption = {
            text: "Select Fuel Type",
            value: null
          };
          item?.dropdownList?.unshift(defaultFuelTypeOption);
          let fuelTypeDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setFuelTypeDropDownList(fuelTypeDropdownListTemp)
        }
      })
    }
  },[vehicle?.searchDropdowns])

 
useEffect(()=> {
  managedEquipRef.current[1]?.focus()
},[])

const handleSelectionChange = (e: any, item: any, name: string, nextField: number) => {
  let globalValues = {
    orderDetails: orderDetails,
    vehicle: vehicle,
    dispatch: dispatch,
  }
  commonDropDownSelectionChange(item, name, nextField, globalValues, setOrderData, managedEquipRef)
}
  return (
    <TreeCare
        managedEquipmentValues={vehicle?.searchCriteria}
        equipmentTypeDropDownList={equipmentTypeDropDownList}
        manufacturerDropDownList={manufacturerDropDownList}
        horsePowerDropDownList={horsePowerDropDownList}
        fuelTypeDropDownList={fuelTypeDropDownList}
        managedEquipRef={managedEquipRef}
        handleSelectionChange={handleSelectionChange}
    />
  )
}

export default TreeCareContainer;
